module.exports = __webpack_public_path__ + "assets/mvp-726c3655029cd26c93ad502a838077bd.svg";